import {createAppAsyncThunk} from '../appAsyncThunk';

export const setIsBusy = createAppAsyncThunk(
  'global/setIsBusy',
  async (isBusy: boolean) => {
    return isBusy;
  },
);
